import { useSelector } from "react-redux";
import { RootState } from "../../store";
import useWindowWidth from "../../hooks/useWindowWidth";
import { formatDateTime } from "../../helpers/date-time/dateTimeHelpers";
import ResponsiveInvoiceTable from "./ResponsiveInvoiceTable";
import TenantInvoicePDFButton from "./TenantInvoicePDFButton";

const InvoiceTable: React.FC = () => {

    const reportState = useSelector((state: RootState) => state.reportState);
    const { tenantInvoiceList } = reportState;
    const { windowWidth } = useWindowWidth()

    return (
        <>
            {
                windowWidth >= 1000
                ?
            
                <table>
                    <thead>
                        <tr>
                            <th>Number</th>
                            <th>Period</th>
                            <th>Amount</th>
                            <th>Fee</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tenantInvoiceList.map(tenantInvoice => {
                            const { 
                                _id,
                                createdAt,
                                invoiceNumber,
                                invoiceAmount,
                                invoiceFeeAmount,
                                isPaid
                            } = tenantInvoice;

                            const { month, year } = formatDateTime(new Date(createdAt * 1000));

                            return (
                                <tr key = {_id}>
                                    <td>{invoiceNumber}</td>
                                    <td>{`${month} ${year}`}</td>
                                    <td>€{invoiceAmount.toFixed(2)}</td>
                                    <td>€{invoiceFeeAmount.toFixed(2)}</td>
                                    <td>{isPaid ? "Paid" : "Not Paid"}</td>
                                    <td>
                                        <TenantInvoicePDFButton 
                                            tenantInvoice={tenantInvoice}
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                :
            <ResponsiveInvoiceTable />
            }
        </>
    );

}

export default InvoiceTable;